
var GalleryDetails         = function () {
    this.Name              = String;
    this.GalleryKey        = String;
    this.GalleryLogoUrl    = String;
    this.SearchResultLimit = Number;
    this.DefaultPageSize   = Number;
    this.IsCurrentGallery  = Number;
    this.LastLoadedOn      = Date;
    this.GalleryStartDate  = String;
    this.IsContentManagementEnabled = Boolean;
    this.ContentManagerTokenHash = String;
    this.IsPictureApprovalModeEnabled = Boolean;
    this.MetaDataLastUpdatedOn      = Date;
    this.PrimaryDateFilterField = String;
    this.DefaultStartDateOffset  = Number;

}

module.exports = GalleryDetails;